import { useState } from 'react';
import { useColourSettingContext } from 'context/ColourSettingProvider';
import ToggleButton from '@mui/material/ToggleButton';
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup';
import { Box } from '@mui/material';
import { SubHeading } from 'components/CommonComponents';
import { PAD_SMALL } from 'providers/designSystem';

export const ColourSetting = () => {
    const [colourSetting, setColourSetting] = useColourSettingContext();
    const [newColourSetting, setNewColourSetting] = useState(colourSetting);

    const handleChange = (event, newColourSetting) => {
        setNewColourSetting(newColourSetting);
        setColourSetting(newColourSetting);
    };

    return (
        <Box display={'grid'} gap={PAD_SMALL}>
            <SubHeading>Colour Setting</SubHeading>
            <ToggleButtonGroup value={newColourSetting} exclusive onChange={handleChange} aria-label="colour setting">
                <ToggleButton value="hsl" aria-label="hsl">
                    hsl
                </ToggleButton>
                <ToggleButton value="hex" aria-label="hex">
                    hex
                </ToggleButton>
            </ToggleButtonGroup>
        </Box>
    );
};
